<template>
    <UButton variant="solid" 
        :label="label" 
        :icon="icon" 
        :class="buttonClasses"
        :ui="{ icon: { base: 'w-5 h-5 sm:w-7 sm:h-7' } }"
    >
    </UButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    icon: {
        type: String,
        default: ''
    },
    colorscheme: {
        type: String,
        default: 'white',
        required: true
    }
})

const colorSchemes = {
    white: {
        color: 'dark:bg-white',
        text: 'black',
        hover: 'dark:hover:bg-gray-300',
        border: 'border-black'
    },
    navtilemintstrong: {
        color: 'dark:bg-navtile-mint-strong',
        text: 'dark:text-white',
        hover: 'dark:hover:bg-navtile-mint-strong-hover',
        border: 'border-white'
    },
    navtileyellowstrong: {
        color: 'dark:bg-navtile-yellow-strong',
        text: 'dark:text-white',
        hover: 'dark:hover:bg-navtile-yellow-strong-hover',
        border: 'border-white'
    },
    navtileredstrong: {
        color: 'dark:bg-navtile-red-strong',
        text: 'dark:text-white',
        hover: 'dark:hover:bg-navtile-red-strong-hover',
        border: 'border-white'
    },
    backbuttonblue: {
        color: 'dark:bg-backbutton-blue',
        text: 'dark:text-white',
        hover: 'dark:hover:bg-backbutton-blue-hover',
        border: 'border-white'
    },
    backbuttongreen: {
        color: 'dark:bg-backbutton-green',
        text: 'dark:text-white',
        hover: 'dark:hover:bg-backbutton-green-hover',
        border: 'border-white'
    }
}

const color = computed(() => {
    return colorSchemes[props.colorscheme].color || colorSchemes.white.color
})

const text = computed(() => {
    return colorSchemes[props.colorscheme].text || colorSchemes.white.text
})

const hover = computed(() => {
    return colorSchemes[props.colorscheme].hover || colorSchemes.white.hover
})

const border = computed(() => {
    return colorSchemes[props.colorscheme].border || colorSchemes.white.border
})

const buttonClasses = computed(() => {
    return [
        'font-inter',
        'text-base sm:text-xl',
        'rounded-lg sm:rounded-xl',
        'h-10 sm:h-14',
        'px-3 sm:px-4',
        'border sm:border-2',
        color.value,
        text.value,
        border.value,
        hover.value
    ]
})
</script>